module.exports = __webpack_public_path__ + "static/img/toplogo.6b31ca89.png";